module.exports = __webpack_public_path__ + "img/tyr-bg.89590c69.webp";